import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { MiddlewareAdapterService } from "./adapter-service";
import { CurrentUser, UserRoleEnum } from "tir-pm-user-core";

/**Сервис для отправки запросов */
const adapterService = new MiddlewareAdapterService();

/**Выброс пользователя из маршрута */
const ejectUser = (next: NavigationGuardNext) => {
  next({ name: "projects-list" });
};

/**Является ли пользователь админом проекта */
export const checkTeam = async (
  route: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  //Проверка наличия доступа к проекту
  const teamResponse = await adapterService.GetCountEmployeesUser();
  if (CurrentUser.Roles.includes(UserRoleEnum.Owner)) return true;

  if (!teamResponse.Value) {
    ejectUser(next);
    return false;
  }
  return true;
};
